<template>
  <div class="mutli-upload">
    <div class="tool-bar">
      <div>
        共选择
        <span class="file-num">{{ fileList.length }}</span>
        个文件
      </div>
      <div class="tool-bar_btn">
        <el-upload
          class="upload-demo"
          ref="upload"
          action="#"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          :http-request="customUpload"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :file-list="fileList"
          :show-file-list="false"
          :auto-upload="false"
        >
          <el-button
            slot="trigger"
            size="medium"
            type="primary"
            icon="el-icon-folder-opened"
            >选择文件</el-button
          >
        </el-upload>
      </div>
    </div>
    <div class="file-list">
      <div class="file-head col3">
        <span>文件名称</span>
        <span>大小</span>
        <span>操作</span>
      </div>
      <div class="file-body">
        <div
          class="file-item col3"
          v-for="(item, index) in fileList"
          :key="index"
        >
          <span>{{ item.name }}</span>
          <span>{{ formatFileSize(item.size) }}</span>
          <div class="file-action">
            <i class="el-icon-delete" @click="handleRemoveFile(index)"></i>
          </div>
        </div>
        <div v-if="!fileList.length" class="no-data">
          <img src="@/assets/img/table.png" alt="没有数据" srcset="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MutliUpload",
  data() {
    return {
      fileList: []
    };
  },
  methods: {
    // 自定义上传方法
    customUpload(options) {},

    // 提交上传
    submitUpload() {
      if (this.fileList.length === 0) {
        this.$message.warning("请先选择文件");
        return false;
      }
      return this.fileList;
      //自定义上传方法
      // this.$refs.upload.submit();
    },

    // 文件状态改变时的钩子
    handleChange(file, fileList) {
      this.fileList = fileList;
    },

    // 文件超出数量限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning("只能上传一个文件，请先删除当前文件后再选择新文件");
    },
    // 上传前的校验
    beforeUpload(file) {
      // 检查文件类型
      const allowedTypes = ["doc", "docx", "xls", "xlsx", "pdf"];
      const fileExtension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      const isAllowedType = allowedTypes.includes(fileExtension);

      if (!isAllowedType) {
        this.$message.warning(
          "文件格式不正确，请上传 doc/docx/xls/xlsx/pdf 格式的文件"
        );
        return false;
      }

      // 检查文件大小 (100MB)
      // const isLt100M = file.size / 1024 / 1024 < 100;
      // if (!isLt100M) {
      //   this.$message.warning("文件大小不能超过 100MB");
      //   return false;
      // }

      return true;
    },

    // 文件移除时的处理
    handleRemove(file, fileList) {},
    handleRemoveFile(index) {
      this.fileList.splice(index, 1);
    },
    // 格式化文件大小显示
    formatFileSize(size) {
      if (size < 1024) {
        return size + " B";
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + " KB";
      } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + " MB";
      } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + " GB";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.mutli-upload {
  .tool-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    &_btn {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .file-num {
      color: #409eff;
      font-size: 14px;
    }
  }
  .file-list {
    .file-action {
      padding-left: 6px;
      cursor: pointer;
      &:hover {
        color: #ff6c66;
      }
    }
    .file-head {
      height: 28px;
      line-height: 28px;
      background-color: #f4f4f5;
      font-weight: 600;
      span:first-child {
        padding-left: 10px;
      }
    }
    .file-body {
      min-height: 150px;
      max-height: 300px;
      overflow-y: auto;
      border: 1px solid #f4f4f5;
    }
    .file-item {
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      span:first-child {
        padding-left: 10px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .col3 {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 100px 60px;
      gap: 10px;
    }
  }
  .no-data{
    display: flex;
    justify-content: center;
  }
}
</style>
